"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
;
class EventBus {
    constructor() {
        this.handlers = {};
    }
    static raise(bus, name, ...args) {
        const handlers = bus.handlers[name];
        if (!handlers)
            return false;
        for (let i = 0; i < handlers.length; i++) {
            const handled = handlers[i].handler(...args);
            if (handled === true) {
                return true;
            }
        }
        return false;
    }
    static raise0(bus, name) {
        const handlers = bus.handlers[name];
        if (!handlers)
            return false;
        for (let i = 0; i < handlers.length; i++) {
            const handled = handlers[i].handler();
            if (handled === true) {
                return true;
            }
        }
        return false;
    }
    static raise1(bus, name, arg0) {
        const handlers = bus.handlers[name];
        if (!handlers)
            return false;
        for (let i = 0; i < handlers.length; i++) {
            const handled = handlers[i].handler(arg0);
            if (handled === true) {
                return true;
            }
        }
        return false;
    }
    addHandler(name, handler, token) {
        let handlers = this.handlers[name];
        if (!handlers)
            handlers = this.handlers[name] = [];
        handlers.push({ token, handler });
    }
    removeHandler(nameOrToken, handler) {
        if (handler) {
            const name = nameOrToken;
            const handlers = this.handlers[name];
            if (!handlers)
                return;
            const index = handlers.findIndex(h => h.handler === handler);
            if (index < 0)
                return;
            handlers.splice(index, 1);
        }
        else {
            const token = nameOrToken;
            if (token === undefined)
                return;
            for (const prop in this.handlers) {
                const handlers = this.handlers[prop];
                if (!handlers)
                    continue;
                for (let i = 0; i < handlers.length; i++) {
                    if (handlers[i].token === token) {
                        handlers.splice(i, 1);
                        i--;
                    }
                }
            }
        }
    }
}
exports.EventBus = EventBus;
//# sourceMappingURL=EventBus.js.map